'use client';

import {
  sendOpenInStrapi,
  type OpenInStrapiTarget,
} from '@klickibunti/pagebuilder-react';
import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { useOptionalRenderContext } from '@/lib/render/RenderContextProvider';

interface Props {
  target: OpenInStrapiTarget;
  className?: string;
}

// Small "Edit in Strapi →" badge attached to lookup-widget rendered content.
// Concept §9.1: lookup-widget rendered content is *not* inline-editable;
// editors deep-link to the source record instead. Renders only inside the
// preview iframe — hidden in live SSR and preview-as-URL.
export function EditInStrapiBadge({ target, className = '' }: Props) {
  const ctx = useOptionalRenderContext();
  if (ctx?.mode !== 'preview-iframe') {
    return null;
  }
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        sendOpenInStrapi(target);
      }}
      className={classNames(
        'inline-flex items-center gap-1 rounded bg-black/70 px-2 py-1 text-xs font-medium text-white hover:bg-black/90',
        className,
      )}
    >
      Edit in Strapi →
    </button>
  );
}
